import { useCallback } from "react";
import type {
  EventTransformerHooks,
  UseInstantTransformEvent,
} from "@b2bportal/core-tracking";
import type {
  HotelUpSellFailedRawEvent,
  HotelUpSellFailedEvent,
  TappedHotelUpSellModalCtaRawEvent,
  TappedHotelUpSellModalCtaEvent,
  TappedHotelUpSellRawEvent,
  TappedHotelUpSellEvent,
  UpSellEvent,
  UpSellRawEvent,
  ViewedHotelUpSellModalRawEvent,
  ViewedHotelUpSellModalEvent,
  ViewedHotelUpSellRawEvent,
  ViewedHotelUpSellEvent,
} from "./events";
import { RbcUpSellEventName, UpSellRawEventName } from "./events";

export const useViewedHotelUpSellTransformer: UseInstantTransformEvent<
  ViewedHotelUpSellRawEvent,
  ViewedHotelUpSellEvent
> = () =>
  useCallback(
    (event) => ({
      name: RbcUpSellEventName.viewed_hotel_up_sell,
      properties: event.properties,
    }),
    []
  );

export const useTappedHotelUpSellTransformer: UseInstantTransformEvent<
  TappedHotelUpSellRawEvent,
  TappedHotelUpSellEvent
> = () =>
  useCallback(
    (event) => ({
      name: RbcUpSellEventName.tapped_hotel_up_sell,
      properties: event.properties,
    }),
    []
  );

export const useViewedHotelUpSellModalTransformer: UseInstantTransformEvent<
  ViewedHotelUpSellModalRawEvent,
  ViewedHotelUpSellModalEvent
> = () =>
  useCallback(
    (event) => ({
      name: RbcUpSellEventName.viewed_hotel_up_sell_modal,
      properties: event.properties,
    }),
    []
  );

export const useTappedHotelUpSellModalCtaTransformer: UseInstantTransformEvent<
  TappedHotelUpSellModalCtaRawEvent,
  TappedHotelUpSellModalCtaEvent
> = () =>
  useCallback(
    (event) => ({
      name: RbcUpSellEventName.tapped_hotel_up_sell_modal_cta,
      properties: event.properties,
    }),
    []
  );

export const useHotelUpSellFailedTransformer: UseInstantTransformEvent<
  HotelUpSellFailedRawEvent,
  HotelUpSellFailedEvent
> = () =>
  useCallback(
    (event) => ({
      name: RbcUpSellEventName.hotel_up_sell_failed,
      properties: event.properties,
    }),
    []
  );

export const UP_SELL_EVENT_TRANSFORMER_HOOKS: EventTransformerHooks<
  UpSellRawEvent,
  UpSellEvent
> = {
  [UpSellRawEventName.ViewedHotelUpSell]: [useViewedHotelUpSellTransformer],
  [UpSellRawEventName.TappedHotelUpSell]: [useTappedHotelUpSellTransformer],
  [UpSellRawEventName.ViewedHotelUpSellModal]: [
    useViewedHotelUpSellModalTransformer,
  ],
  [UpSellRawEventName.TappedHotelUpSellModalCta]: [
    useTappedHotelUpSellModalCtaTransformer,
  ],
  [UpSellRawEventName.HotelUpSellFailed]: [useHotelUpSellFailedTransformer],
};
